import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {
    BaseConfirmationDialogOptions,
    ConfirmationDialogComponent,
} from 'app/_services/dialogs/confirmation/confirmation-dialog.component';
import { Observable, Subscription } from 'rxjs';
import { ScreenSizeService } from '../screensize/screensize.service';
import { BaseCountdownDialogOptions, CountdownDialogComponent } from './countdown/countdown.dialogcomponent';
import { BaseLoginBoxDialogOptions, BaseLoginBoxDialogResult, LoginBoxDialogComponent } from './loginbox/loginbox.dialogcomponent';
import { BaseMessageBoxDialogOptions, MessageBoxDialogComponent } from './messagebox/messagebox.dialogcomponent';

@Injectable({
    providedIn: 'root',
})
export class DialogsService implements OnDestroy {
    private openHandle: MatDialogRef<any>;
    private _subrelease: Subscription = new Subscription();

    smallMediaSize: boolean;

    constructor(private matDialog: MatDialog, private mediaChange: ScreenSizeService) {
        this.smallMediaSize = mediaChange.ScreenSize.IsSmallSize;

        // Observe for media changes
        this._subrelease.add(
            this.mediaChange.ScreenSizeSub.subscribe((media) => {
                // Set flags accordingly with what we know.
                this.smallMediaSize = media.IsSmallSize;
            })
        );
    }

    ngOnDestroy(): void {
        // this._subrelease.unsubscribe();
    }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Confirmation Dialog Service Call

    OpenConfirmationDialog(options?: BaseConfirmationDialogOptions): Observable<boolean> {
        // const self = this;
        const dlgoptions: MatDialogConfig<any> = {
            disableClose: true,
            data: {
                TitleText: 'Confirmation Requested...',
                MessageText: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                ...options,
            },
            panelClass: 'confdialog',
            maxWidth: '450px',
            maxHeight: '85vh',
        };

        // if (self.smallMediaSize) {
        //     dlgoptions.panelClass = ['confdialog', 'smalldialogpanel'];
        // }

        const openHandle = this.matDialog.open<ConfirmationDialogComponent>(ConfirmationDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion

    // #region Open Countdown Dialog Service Call

    OpenCountdownDialog(options?: BaseCountdownDialogOptions): Observable<boolean> {
        const self = this;

        const dlgoptions: MatDialogConfig<any> = {
            disableClose: true,
            data: {
                TitleText: 'Please Wait...',
                MessageText: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                Time: 60,
                ...options,
            },
            width: '500px',
            height: '18rem',
            maxHeight: '85vh',
        };

        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            // dlgoptions.height = '80vh';
            dlgoptions.height = '30rem';
            dlgoptions.panelClass = 'smalldialogpanel';
        }

        const openHandle = this.matDialog.open<CountdownDialogComponent>(CountdownDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion

    // #region Open Login Box Dialog Service Call

    OpenLoginBoxDialog(options?: BaseLoginBoxDialogOptions): Observable<BaseLoginBoxDialogResult> {
        const openHandle = this.matDialog.open<LoginBoxDialogComponent>(LoginBoxDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Credentials Required...',
                MessageText: '',
                InputHint: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                ...options,
            },
            maxHeight: '85vh',
            // width: '500px',
            // height: (options && options.height) || '13rem'
        });

        return openHandle.afterClosed();
    }

    // #endregion

    // #region Open Message Box Dialog Service Call

    OpenMessageBoxDialog(options?: BaseMessageBoxDialogOptions): Observable<boolean> {
        const self = this;

        const openHandle = self.matDialog.open<MessageBoxDialogComponent>(MessageBoxDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Information',
                MessageText: '',
                OKText: 'OK',
                ...options,
            },
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
            maxHeight: '85vh',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}
